var _defs, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJsColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0a110d4a5d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37.5 37.5 L 337.5 37.5 L 337.5 337.5 L 37.5 337.5 Z M 37.5 37.5 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0a110d4a5d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7df1e",
    d: "M 37.5 37.5 L 337.5 37.5 L 337.5 337.5 L 37.5 337.5 Z M 37.5 37.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 116.382812 288.199219 L 139.339844 274.3125 C 143.769531 282.164062 147.796875 288.808594 157.464844 288.808594 C 166.722656 288.808594 172.570312 285.175781 172.570312 271.089844 L 172.570312 175.230469 L 200.753906 175.230469 L 200.753906 271.488281 C 200.753906 300.679688 183.644531 313.980469 158.671875 313.980469 C 136.117188 313.980469 123.027344 302.296875 116.378906 288.199219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 216.070312 285.175781 L 239.027344 271.886719 C 245.074219 281.753906 252.925781 289.007812 266.8125 289.007812 C 278.496094 289.007812 285.949219 283.171875 285.949219 275.109375 C 285.949219 265.441406 278.296875 262.019531 265.40625 256.382812 L 258.363281 253.359375 C 238.019531 244.699219 224.53125 233.835938 224.53125 210.867188 C 224.53125 189.726562 240.632812 173.613281 265.816406 173.613281 C 283.734375 173.613281 296.625 179.859375 305.882812 196.171875 L 283.933594 210.269531 C 279.105469 201.609375 273.867188 198.1875 265.816406 198.1875 C 257.554688 198.1875 252.316406 203.425781 252.316406 210.269531 C 252.316406 218.730469 257.554688 222.152344 269.636719 227.390625 L 276.679688 230.402344 C 300.644531 240.679688 314.144531 251.144531 314.144531 274.710938 C 314.144531 300.082031 294.210938 313.980469 267.421875 313.980469 C 241.242188 313.980469 224.332031 301.488281 216.070312 285.175781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJsColor);
export default __webpack_public_path__ + "static/media/js-color.93063298ed60006d37c860b86ceaf3ba.svg";
export { ForwardRef as ReactComponent };